import { requestApi } from "../apiService";
import { ApiEndpoints } from "../apiEndpoints";
import { TermsDocument } from "../types/terms";

export const fetchCurrentTerms = async (): Promise<TermsDocument> => {
  const response = await requestApi({
    url: ApiEndpoints.TERMS_CURRENT,
    method: "GET",
  });
  return response.data as TermsDocument;
};

export const acceptTerms = async (version: string): Promise<void> => {
  await requestApi({
    url: ApiEndpoints.TERMS_ACCEPT,
    method: "POST",
    data: { version },
  });
};
